import { connect } from "react-redux";
import { Dispatch } from "redux";
import { Action } from "redux";
import { Button, Table } from 'antd';
import { AgentCommissionVersion } from 'app/pages/AgentPricing/modules/PublishedVersions/state';
import { getPublishedAgentCommission } from 'app/pages/AgentPricing/modules/PublishedVersions';
import { getAgentName } from 'app/pages/AgentPricing/modules/RefData';
import { DateTimeDisplay } from 'app/shared/ui/DateTimeDisplay';
import { changeSelectedPublishedVersion } from 'app/pages/AgentPricing/actions';
import PublishedVersionDialog from 'app/pages/AgentPricing/components/PublishedVersionDialog';

export interface PublishedVersionsTableProps {}

interface StateProps {
    versions: AgentCommissionVersion[]
    agentName: string
}

interface DispatchProps {
    viewVersion: (versionCode: string) => void
}

type InternalProps = StateProps & DispatchProps; 

const PublishedVersionsTable = (props: InternalProps) => {
    const columns = [
        {
            title: 'Version',
            dataIndex: 'name',
            key: 'name',
            width: '45%'
        },
        {
            title: 'Rates for',
            dataIndex: 'ratesFor',
            key: 'ratesFor',
            width: '20%',
            render: (_: unknown, record: AgentCommissionVersion) =>
                record.ratesFor ?? `Group: ${props.agentName || 'Agent'}`
        },
        {
            title: 'Last updated by',
            dataIndex: 'lastUpdatedBy',
            key: 'lastUpdatedBy',
            width: '15%'
        },
        {
            title: 'Date last updated',
            key: 'lastUpdatedDate',
            width: '12%',
            render: (_: string, record: AgentCommissionVersion) =>
                DateTimeDisplay(record.lastUpdatedDate)
        },
        {
            title: 'Action',
            key: 'action',
            width: '8%',
            render: (_: string, record: AgentCommissionVersion) =>
                record.isCurrent ? null : (
                    <Button type="link" onClick={() => props.viewVersion(record.rates.versionCode)}>
                        View
                    </Button>
                )
        }
    ];

    return <>
        <Table
            columns={columns}
            dataSource={props.versions}
            rowKey={(record: { rates: { versionCode: any; }; }) => record.rates.versionCode}
            pagination={false}
            size="middle"
        />
        <PublishedVersionDialog />
    </>;
}; 

const mapStateToProps = (state: any, ownProps: PublishedVersionsTableProps) => {
    return {
        versions: getPublishedAgentCommission(state),
        agentName: getAgentName(state)
    }
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) : DispatchProps => {
    return {
        viewVersion: (versionCode: string) => dispatch(changeSelectedPublishedVersion(versionCode)) 
    }; 
}

export default connect(mapStateToProps, mapDispatchToProps)(PublishedVersionsTable);